import { render } from "./ItemId.vue?vue&type=template&id=9768b9da&ts=true"
import script from "./ItemId.vue?vue&type=script&lang=ts"
export * from "./ItemId.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__